// ============================================================
// PORTFOLIO DATA — Edit this file to personalize your portfolio
// ============================================================

export const personalInfo = {
  name: "Safouane Rady",
  tagline: "Full-Stack Developer",
  email: "safouanekira2001@gmail.com",
  phone: "+212762040115",
  location: "DRARGA AGADIR",
  bio: `I'm a passionate full-stack developer with a strong foundation in PHP, Laravel, React, and SQL. I love turning creative ideas and complex problems into functional, user-friendly web applications. When I'm not coding, you'll find me exploring innovative project concepts, learning new technologies, or working on niche web projects that push my skills further..`,
  resumeUrl: "#",
  profileImage: process.env.PUBLIC_URL + "/profile.jpeg",
};

export const socialLinks = {
  github: "https://github.com/SafouaneRady",
  linkedin: "https://www.linkedin.com/in/safouane-rady-b60144348/",
  gmail: "mailto:safouanekira2001@gmail.com",
  instagram: "https://www.instagram.com/saf1rady/",
};

export const navLinks = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "projects", label: "Projects" },
  { id: "experience", label: "Education" },
  { id: "contact", label: "Contact" },
];

export const skills = [
  {
    category: "Frontend",
    items: [
      { name: "React", icon: "FaReact" },
      { name: "JavaScript", icon: "SiJavascript" },
      { name: "TypeScript", icon: "SiTypescript" },
      { name: "CSS / SCSS", icon: "FaCss3Alt" },
    ],
  },
  {
    category: "Backend",
    items: [
      { name: "PHP", icon: "SiPhp" },
      { name: "Laravel", icon: "SiLaravel" },
      { name: "Node.js", icon: "FaNodeJs" },
      { name: "Python", icon: "FaPython" },
    ],
  },
  {
    category: "Databases",
    items: [
      { name: "MongoDB", icon: "SiMongodb" },
      { name: "PostgreSQL", icon: "SiPostgresql" },
    ],
  },
  {
    category: "Tools & DevOps",
    items: [
      { name: "Git & GitHub", icon: "FaGitAlt" },
      { name: "Docker", icon: "FaDocker" },
      { name: "Figma", icon: "FaFigma" },
    ],
  },
];

export const funFacts = [
  "☕ Fueled by 3+ cups of coffee daily",
  "💪 Gym addict — never skip leg day",
  "♟️ Chess enthusiast always thinking 3 moves ahead",
  "🎬 Movie buff with an ever-growing watchlist",
];

export const projects = [
  {
    id: 1,
    title: "E-Commerce Platform",
    description:
      "A full-stack e-commerce platform with real-time inventory management, payment processing via Stripe, and an admin dashboard for analytics.",
    techStack: ["React", "Node.js", "MongoDB", "Stripe", "Redux"],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop",
    github: "https://github.com",
    liveDemo: "https://example.com",
    featured: true,
  },
  {
    id: 2,
    title: "Task Management App",
    description:
      "A collaborative task management tool with drag-and-drop boards, real-time updates using WebSockets, and team workspaces.",
    techStack: ["React", "TypeScript", "Socket.io", "PostgreSQL"],
    image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=600&h=400&fit=crop",
    github: "https://github.com",
    liveDemo: "https://example.com",
    featured: true,
  }
];

export const experiences = [
  {
    id: 1,
    type: "education",
    title: "Baccalauréat",
    organization: "Lycée Qalb Alhikma",
    location: "Agadir, Morocco",
    startDate: "Sep 2018",
    endDate: "Jun 2019",
    description:
      "Completed high school with a focus on sciences. Developed strong analytical and problem-solving skills that laid the foundation for a career in tech.",
    technologies: ["Mathematics", "Physics", "French", "Arabic"],
  },
  {
    id: 2,
    type: "education",
    title: "Digital Development Diploma",
    organization: "CMC Agadir",
    location: "Agadir, Morocco",
    startDate: "Sep 2024",
    endDate: "July 2026",
    description:
      "Specialized in full-stack web development. Built multiple projects using React, Laravel, JavaScript, and SQL/NOSQL. Gained hands-on experience with modern development workflows and version control.",
    technologies: ["React", "Laravel", "JavaScript", "SQL", "HTML/CSS"],
  },
];
